<!--
 * @Description: description
 * @Author: chenguobiao
 * @Date: 2021-12-24 22:03:45
 * @LastEditTime: 2022-07-19 11:50:43
 * @LastEditors: chenguobiao
-->
<template>
  <div class="personal-payment page-normal">
    <common-header selected="user" />
    <div class="page-normal__content">
      <div class="personal-payment__box" v-if="orderInfo">
        <div class="row">
          <div class="price--wrap">
            <span>扫一扫支付</span>
            <span><b>￥</b><em>{{type == 1 ? orderInfo.examFee : orderInfo.amount}}</em></span>
          </div>
          <div class="payment--info" v-if="type === 1">
            <p>交易号：{{orderInfo.orderNum}}</p>
            <p>物品：{{orderInfo.productName}}</p>
            <p>参赛等级：国际象棋 {{orderInfo.productLevelName}} 级</p>
            <p>考试时间：{{orderInfo.qualificationStartDate}}-{{orderInfo.qualificationEndDate}}</p>
          </div>
          <div class="payment--info" v-else>
            <p>办证签单号：{{orderInfo.orderNum}}</p>
            <p>收件人：{{orderInfo.recipient}}</p>
            <p>联系电话：{{orderInfo.contactNumber}}</p>
            <p>收件地址：{{orderInfo.receiveAddress}}</p>
          </div>
        </div>
        <div class="row">
          <div class="count--down">
            <span>支付剩余时间：</span>
            <span>{{countDownTimes > 0 ? timesTransition(countDownTimes) : '已失效'}}</span>
          </div>
          <div class="ewm">
            <img :src="ewmSrc">
          </div>
          <div class="payment--method">
            <div class="method" :class="{curr: payType === 'ZFB'}" @click="payType = 'ZFB'">
              <div class="icon--image">
                <img src="@/render/assets/images/personal/icon_alipay.png">
              </div>
              <span>支付宝支付</span>
            </div>
            <!-- <div class="method" :class="{curr: payType === 'WX'}" @click="payType = 'WX'">
              <div class="icon--image">
                <img src="@/render/assets/images/personal/icon_wechat.png">
              </div>
              <span>微信支付</span>
            </div> -->
          </div>
        </div>
        <common-back :backHome="!back"/>
      </div>
    </div>
    <payment-result-dialog :visible="dialogConfig.visible" :state="dialogConfig.state" :type="type"/>
  </div>
</template>

<script>
import store from 'store'
import { personalAPI } from '@/apis'
import CommonHeader from '@/render/components/common/header'
import CommonBack from '@/render/components/common/back'
import PaymentResultDialog from '@/render/components/dialog/PaymentResult'
import { Timer } from '@/render/utils'
import { USER_INFO, COUNTDOWN } from '@/config/const'
let countDownTimer = null
let repeatedCallTimer = null
export default {
  data() {
    return {
      orderNum: '',
      type: 1,
      payType: 'ZFB', // ZFB WX
      orderInfo: null,
      ewmSrc: '',
      countDownTimes: 0,
      dialogConfig: {
        visible: false,
        state: 1
      },
      back: 0
    }
  },
  computed: {
    combination() {
      return `${this.payType}|${this.orderNum}`
    }
  },

  watch: {
    async combination(combination) {
      const [payType, orderNum] = combination.split('|')
      if (payType && orderNum) {
        if (this.countDownTimes > 0) {
          const { data } = await personalAPI.postCreateQRCode({
            type: this.type,
            userType: store.get(USER_INFO).userType,
            payType,
            orderNum
          })
          this.ewmSrc = data
        } else {
          this.ewmSrc = require('@/render/assets/images/personal/ewm_failure.png')
        }
      }
    },
    countDownTimes(countDownTimes) {
      if (countDownTimes === 0) {
        this.ewmSrc = require('@/render/assets/images/personal/ewm_failure.png')
      }
    },
    '$route.query': {
      immediate: true,
      handler(query) {
        let { orderNum, back, type } = query
        if (orderNum) {
          this.back = typeof back === 'string' ? Number(back) : 0
          this.type = typeof type === 'string' ? Number(type) : 1
          this.getOrderInfo(orderNum)
        } else {
          this.$router.replace('/home')
        }
      }
    }
  },
  components: {
    CommonHeader,
    CommonBack,
    PaymentResultDialog
  },
  mounted() {

  },
  destroyed() {
    countDownTimer && countDownTimer.stop()
    // repeatedCallTimer
    clearTimeout(repeatedCallTimer)
  },
  methods: {
    getApi() {
      return this.type == 1 ? personalAPI.postGetOrderInfo : personalAPI.postGetCertificateInfo
    },
    async getOrderInfo(orderNum) {
      const { data } = await this.getApi()({
        orderNum
      })
      this.orderInfo = data
      this.orderNum = orderNum
      const state = this.type === 1 ? data.productState : data.state
      if (this.type === 1 && [1, 2].includes(state) || this.type === 2 && state === 1) {
        this.startCountDown()
        this.RepeatedCallGetOrderState(orderNum)
      } else {
        this.dialogConfig.visible = true
        this.dialogConfig.state = state
      }
    },
    startCountDown() {
      let countDownTimes = 900 - Math.ceil((new Date(this.orderInfo.nowTime).getTime() - new Date(this.orderInfo.createTime).getTime()) / 1000)
      if (countDownTimes <= 0) return
      this.countDownTimes = countDownTimes
      countDownTimer = new Timer(this.countDownTimes)
      countDownTimer.start(this.$bus, COUNTDOWN)
      this.$bus.on(COUNTDOWN, countDownTimes => {
        this.countDownTimes = countDownTimes
        if (countDownTimes === 0) countDownTimer.stop()
      })
    },
    timesTransition(times) {
      const minute = parseInt(times / 60)
      const seconds = times - minute * 60
      return `${String(minute).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
    },
    async getOrderState(orderNum) {
      const { data } = await this.getApi()({
        orderNum
      })
      return this.type === 1 ? data.productState : data.state
    },
    RepeatedCallGetOrderState(orderNum) {
      repeatedCallTimer = setTimeout(async () => {
        const state = await this.getOrderState(orderNum)
        if (this.type === 1 && [1, 2].includes(state) || this.type === 2 && state === 1) {
          this.RepeatedCallGetOrderState(orderNum)
        } else {
          this.dialogConfig.visible = true
          this.dialogConfig.state = state
          countDownTimer.stop()
        }
      }, 1500)
    }
  }
}
</script>

<style lang="scss" scoped>
  .personal-payment {
    &__box {
      position: relative;
      width: val(1200);
      margin: val(24) auto 0;
      background: url(../../../assets/images/personal/chess_bg.png) #fff left top no-repeat;
      background-size: 100%;
      .row {
        &:first-of-type {
          padding: val(40) val(20) 0;
          height: val(155);
          background: #FBEEE0;
          border-radius: val(15) val(15) 0px 0px;
          box-sizing: border-box;
          .price--wrap {
            margin-bottom: val(30);
            display: flex;
            justify-content: center;
            align-items: flex-end;
            span {
              &:first-of-type {
                line-height: val(20);
                font-size: val(16);
                color: #000000;
              }
              &:last-of-type {
                display: flex;
                align-items: flex-end;
                color: #FF9100;
                b {
                  line-height: val(16);
                  font-weight: 500;
                  font-size: val(16);
                }
                em {
                  margin-bottom: val(-1);
                  font-style: normal;
                  line-height: val(28);
                  font-size: val(28);
                  font-weight: 500;
                }
              }
            }
          }
          .payment--info {
            display: flex;
            justify-content: space-between;
            p {
              line-height: val(16);
              font-size: val(16);
              color: #777777;
            }
          }
        }
        &:nth-of-type(2) {
          padding: val(32) 0 val(123);
          display: flex;
          flex-direction: column;
          align-items: center;
          .count--down {
            display: flex;
            align-items: center;
            margin-bottom: val(20);
            span {
              &:first-of-type {
                line-height: val(16);
                font-size: val(16);
                color: #666666;
              }
              &:last-of-type {
                line-height: val(16);
                font-size: val(16);
                color: #FF9100;
              }
            }
          }
          .ewm {
            display: flex;
            align-items: center;
            justify-content: center;
            width: val(360);
            height: val(360);
            background: #FFFFFF;
            box-shadow: 0px val(2) val(6) rgba(0, 0, 0, 0.16);
            border-radius: val(4);
            margin-bottom: val(54);
            img {
              width: 100%;
            }
          }
          .payment--method {
            display: flex;
            .method {
              width: val(128);
              height: val(42);
              background: #FFFFFF;
              border: 1px solid #D5DBE1;
              border-radius: val(4);
              margin-right: val(30);
              font-size: val(14);
              color: #999999;
              display: flex;
              align-items: center;
              justify-content: center;
              .icon--image {
                margin-right: val(8);
                width: val(24);
              }
              &:last-of-type {
                margin-right: 0;
              }
              &.curr {
                border: 1px solid #0077E8;
                box-shadow: 0 val(3) val(6) rgba(68, 130, 254, 0.2);
                color: #0077E8;
              }
            }
          }
        }
      }
    }
  }
</style>
